export default {
    TOGGLE_LOADING: 'TOGGLE_LOADING',
    TRANSLATE_UGC: 'TRANSLATE_UGC',
    DISPLAY_EXPRESS_RECOMMENDATION: 'DISPLAY_EXPRESS_RECOMMENDATION',
    SET_LISTINGS: 'SET_LISTINGS',
    SET_IS_LOADING_LISTINGS: 'SET_IS_LOADING_LISTINGS',
    SET_RECOMMENDATIONS_LISTINGS: 'SET_RECOMMENDATIONS_LISTINGS',
};
